import { useTranslation } from "react-i18next";

const AuthFooter = (props) => {
    const {t} = useTranslation();
    return (
       <div className="AthFtrSec">
            <div className="container">
                <div className="AthFtrLk">
                    <ul>
                        <li>
                            <a href="/privacy">{t('Privacy Policy')}</a>
                        </li>
                        <li>
                            <a href="/terms">{t('Terms and Conditions')}</a>
                        </li>
                    </ul>
                    <p>© 2026 KKOG. {t('All Right Reserved')}. </p>
                </div>
            </div>
       </div>
    );   
}

export default AuthFooter;